// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".light-mode .border-grey[data-v-3809d68c]{border-color:#ccc}.dark-mode .border-grey[data-v-3809d68c]{border-color:#999}.limit-note-width[data-v-3809d68c]{max-width:20rem}.modal-width[data-v-3809d68c]{width:26rem}.btn-height[data-v-3809d68c]{height:3.25rem}@media screen and (max-width:1023px){.modal-width[data-v-3809d68c]{width:unset}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
